import { useEffect, useState, useRef, useCallback } from "react"
import { FormatDateForCard } from "../../../utilities/FormatDate"


export const SessionSelectorSection = ({ feedings, isSmallCard = true, currentTimestamp, onDateClick }) => {

    const [index, setIndex] = useState(0);
    const [maxCards, setMaxCards] = useState(4);
    const [direction, setDirection] = useState('right');

    const containerRef = useRef(null);
    const pillRef = useRef(null);

    const calculateMaxCards = useCallback(() => {
        if (!containerRef.current) return;
        const containerWidth = containerRef.current.clientWidth; // excludes padding
        const arrowWidth = 64; // reserve space for both arrows
        const pillWidth = pillRef.current ? pillRef.current.offsetWidth + 4 : 108;
        setMaxCards(Math.max(1, Math.floor((containerWidth - arrowWidth) / pillWidth)));
    }, []);

    useEffect(() => {
        calculateMaxCards();
        const observer = new ResizeObserver(calculateMaxCards);
        if (containerRef.current) observer.observe(containerRef.current);
        return () => observer.disconnect();
    }, [calculateMaxCards]);

    const showRight = feedings.length > index + maxCards;

    function handleLeftClick() {
        setDirection('left');
        setIndex(prev => Math.max(0, prev - maxCards));
    }

    function handleRightClick() {
        if (showRight) {
            setDirection('right');
            setIndex(prev => prev + maxCards);
        }
    }

    return (
        <div ref={containerRef} className="d-flex align-items-center gap-1 px-2 w-100" style={{ height: 30 }}>

            { index > 0
                && <i className='bx bx-chevron-left card-icon' style={{ fontSize: '2rem', flexShrink: 0 }} onClick={handleLeftClick} />
            }

            <div
                key={index}
                className={`d-flex ms-1 gap-1 flex-grow-1 ${direction === 'right' ? 'session-slide-right' : 'session-slide-left'}`}
                style={{ alignItems: 'center' }}
            >
                {feedings.slice(index, index + maxCards).map((feeding, i) =>
                    <div
                        ref={i === 0 ? pillRef : null}
                        className={`px-2 date-selector py-1 rounded-4 ${currentTimestamp === feeding?.timestamp && !isSmallCard ? 'bg-color' : 'bg-green'}`}
                        key={feeding?.timestamp}
                        onClick={() => onDateClick(feeding?.timestamp)}>
                        <p className={`text-sm mb-0 text-nowrap ${currentTimestamp === feeding?.timestamp && !isSmallCard && 'text-selected'}`}>
                            {FormatDateForCard(feeding?.timestamp)}
                        </p>
                    </div>
                )}
            </div>

            { showRight
                ? <i className='bx bx-chevron-right card-icon' style={{ fontSize: '2rem', flexShrink: 0 }} onClick={handleRightClick} />
                : <div style={{ width: 18, flexShrink: 0 }} />
            }

        </div>
    )
}
